module.exports = __webpack_public_path__ + "img/Medical Services.7c27b101.png";